import React from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import StyleDecorator from '../components/StyleDecorator';

import largeBackgroundImage from '../static/images/login-bg-image-large.jpg';

const mapStateToProps = state => ({
	loading: state.view.loading,
});

export class CenteredFormLayout extends React.Component {
	static propTypes = {
		mediaQueries: React.PropTypes.object,
		children: React.PropTypes.object,
		loading: React.PropTypes.bool.isRequired,
	};

	state = {
		showErrorMessage: false,
	};

	getStyle() {
		const MediaQueries = this.props.mediaQueries;

		return {
			flexContainer: {
				display: 'flex',
			},
			backgroundImage: {
				minHeight: '100vh',
				width: '100%',
				alignItems: 'center',
				display: 'flex',
				justifyContent: 'center',
				backgroundImage: (MediaQueries.isMinMediumDevice()) ? 'url(' + largeBackgroundImage + ')' : '',
				backgroundPosition: 'center center',
				backgroundRepeat: 'no-repeat',
				backgroundAttachment: 'fixed',
				backgroundSize: 'cover',
			},
		};
	}

	getLoadingBar() {
		if (this.props.loading) {
			return (
				<div className={'loadingBar'} />
			);
		}

		return null;
	}

	render() {
		const style = this.getStyle();
		return (
			<div // flex container needed to fix centering in ie11
				style={style.flexContainer}
				className={'flex-container'}
			>
				<div
					style={style.backgroundImage}
					className={'flex-container'}
				>
					{this.getLoadingBar()}
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, {})(StyleDecorator(Radium(CenteredFormLayout)));



// WEBPACK FOOTER //
// ./src/layouts/CenteredFormLayout.js